import React, { useEffect, useRef, useState } from 'react';
import { Box, Grid, GridProps, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { isEnvTypePROD } from '../../service/config';
import '../TableauObs/Summary/Summary.scss';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import StorageIcon from '../../assets/storage-summary.svg';
import '../DataEstate/data-estate.scss';
import { getDataEstateKpiSector, getDecodedToken, getDataEstateSector, fetchDEStorageSummary, fetchDEStorageTrends, getSectorSql, fetchDEStorageTable } from '../../service/service';
import { formatByByte } from '../../utils/common-util';
import { CustomizedDataGrid } from '../customized_data_grid';
import { type Column } from 'react-data-grid';
import NumberWidget from 'components/Widgets/NumberWidget';
import ChartWidget from 'components/Widgets/ChartWidget';
import ConversionUnitDropdown from 'components/Dropdown/ConversionUnit';
import PageHeader from 'components/Header/Page';
import { useCacheDataController } from 'Context/contexts/CacheDataContext';
import WidgetCardContainer from 'components/Widgets/WidgetCardContainer';
import LoaderComponent from 'components/Loader';
import SingleSelectFilter from 'components/Dropdown/SingleSelectFilter';
import { sectorListDetails } from 'Context/contexts/cacheData/DataEstate/type';
import PageWrapper from 'components/Common/PageWraper';
import HighlightedText from 'components/GlobalSearch/HighlightText';
import { useHeader } from 'Context/contexts/HeaderTabRightContentContext';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { RefreshIcon } from 'components/CommonIcons/Icons';

const gridChildProps: GridProps = {
	minWidth: '260px',
	flexGrow: 1,
	flexBasis: 0,
	maxWidth: '100%'
};

function formatNumber(number: any) {
	console.info(number, 'number==');
	if (number == null || isNaN(number)) {
		return '0.00';
	}
	else {
		return Number(number).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}
}

const StorageSummary = () => {
	const theme = useTheme();
	const colors = theme.palette as any;
	const { setRightContextContent } = useHeader();
	const [searchParams] = useSearchParams();
	const [controller] = useCacheDataController();
	const { teradataStorageLastSyncDate, conversionUnit } = controller;
	const [sectorName, setSectorName] = useState('all');
	const hasDrillDown = searchParams.has('isDrillDowned');
	const [, setLoading] = useState(false);

	// sector filter
	const userSector = getDecodedToken()?.sector?.name?.toLowerCase();
	const [sectorOptionsList, setSectorOptionsList] = useState<any[]>([]);
	const [, setCheckedList] = useState<any[]>([]);
	const [, setCurrSectorFilter] = useState<any[]>([]);
	const dataFetchedRef = useRef(false);

	const [isLoading, setIsLoading] = useState(false);
	const [TeradataSize, SetTeradataSize] = useState('-');
	const [AdlsSize, SetAdlsSize] = useState('-');
	const [AdlsSizeNoData, SetAdlsSizeNoData] = useState(false);
	const [AzureSqlSize, SetAzureSqlSize] = useState('-');
	const [AzureSqlSizeNoData, SetAzureSqlSizeNoData] = useState(false);
	const [AzureSynapse, SetAzureSynapse] = useState('-');
	const [AzureSynapseNoData, SetAzureSynapseNoData] = useState(false);
	const [AzureCosmos, SetAzureCosmos] = useState('-');
	const [AzureCosmosNoData, SetAzureCosmosNoData] = useState(false);
	const [TeradataSizeRaw, SetTeradataSizeRaw] = useState(0);
	const [AdlsSizeRaw, SetAdlsSizeRaw] = useState(0);
	const [AzureSqlSizeRaw, SetAzureSqlSizeRaw] = useState(0);
	const [AzureSynapseRaw, SetAzureSynapseRaw] = useState(0);
	const [AzureCosmosRaw, SetAzureCosmosRaw] = useState(0);

	const [, setGrafanaAzureLoading] = useState(true);
	const [grafanaAzureOptions, setGrafanaAzureOptions] = useState<any>();
	const [, setGrafanaTeradataLoading] = useState(true);
	const [grafanaTeradataOptions, setGrafanaTeradataOptions] = useState<any>(null);
	const [filterMonth] = useState('0M');
	const selectedByte = useRef('PB');
	const [lastUpdatedDateTeradata, setLastUpdatedDateTeradata] = useState('');
	const [lastUpdatedDateAzure, setLastUpdatedDateAzure] = useState('');

	const [allSectorOptionsList, setAllSectorOptionsList] = useState<sectorListDetails | null>(null);
	const [sectorTagList, setSectorTagList] = useState<any>({ azure: true });


	const [teradataRes, setTeradataRes] = useState<any[]>([]);
	const [azureRes, setAzureRes] = useState<any[]>([]);

	const [allSectorStorageData] = useState(() => {
		const sectorData = localStorage.getItem('storageDetails');
		return sectorData == undefined ? null : JSON.parse(sectorData);
	});

	async function fetchSectorOptionsData() {
		let sectorKpi = [];
		sectorKpi.push("azure");
		const sectorRes = await getDataEstateKpiSector(sectorKpi);
		if (sectorRes.success) {
			if (sectorRes.data) {
				setAllSectorOptionsList(sectorRes.data);
			}
		}
		const sectorKpiRes = await getDataEstateSector();
		if (sectorKpiRes.success) {
			if (sectorKpiRes.data) {
				const sectorValues = sectorKpiRes.data.map((item: { sector: any; }) => item.sector);
				const uniqueSectors = Array.from(new Set(sectorValues));
				const sectorNameList: string[] = uniqueSectors.map(sector =>
					(sector === "" || sector === null || sector === undefined) ? "Blank" : String(sector)
				);
				const sortedSectors = [...sectorNameList].sort((a, b) => a.localeCompare(b));
				setSectorOptionsList(sortedSectors);
			}
		}
	}

	const teradataTrend = (resData: any) => {
		setGrafanaTeradataOptions(resData.data);
		setLastUpdatedDateTeradata(resData.lastUpdatedDate)
		setGrafanaTeradataLoading(false);
	};

	const azureTrend = (resData: any) => {
		setGrafanaAzureOptions(resData.data);
		setLastUpdatedDateAzure(resData.lastUpdatedDate)
		setGrafanaAzureLoading(false);
	};

	async function getStorageSummaryDetails(sectors: any, month: any, from?: string) {
		setIsLoading(true);
		// let sector = sectors.length == sectorOptionsList.length ? [] : sectors;
		// Trend APIs
		if (from == '') {
			SetTeradataSize('-');
			setTeradataRes([]);
		}

		SetAdlsSize('-');
		SetAzureSqlSize('-');
		SetAzureSynapse('-');
		SetAzureCosmos('-');

		setAzureRes([]);
		if (sectors == 'Blank')
			sectors = '';

		Promise.all([
			from == '' ? fetchDEStorageTrends('storage', 'teradata', sectors, month) : '',
			fetchDEStorageTrends('storage', 'azure', sectors, month),
			fetchDEStorageSummary(sectors, month)
		])
			.then(([teradataRes, azureRes, summaryApiRes]) => {
				// Teradata
				if (from == '') {
					setTeradataRes(teradataRes.data);
					teradataTrend(teradataRes.data);
				}

				if (sectors == 'all') {
					localStorage.setItem('storageDetails', JSON.stringify(summaryApiRes.data));
				}
				// Azure
				setAzureRes(azureRes.data);
				azureTrend(azureRes.data);

				// Summary APIs
				let teradataSize = summaryApiRes?.data?.dataStoredInTeradata?.[0]?.['VALUE'] ?? 0;
				SetTeradataSize(formatByByte(conversionUnit, teradataSize));
				SetTeradataSizeRaw(teradataSize);
				if (summaryApiRes?.data?.dataStoredInADLS == 'no data') {
					SetAdlsSizeNoData(true)
				} else {
					let adlsSize = summaryApiRes?.data?.dataStoredInADLS?.[0]?.['VALUE'] ?? 0;
					SetAdlsSize(formatByByte(conversionUnit, adlsSize));//
					SetAdlsSizeRaw(adlsSize);//
				}
				if (summaryApiRes?.data?.dataStoredInSQL == 'no data') {
					SetAzureSqlSizeNoData(true)
				} else {
					let azureSize = summaryApiRes?.data?.dataStoredInSQL?.[0]?.['VALUE'] ?? 0;
					SetAzureSqlSize(formatByByte(conversionUnit, azureSize));
					SetAzureSqlSizeRaw(azureSize);
				}
				if (summaryApiRes?.data?.dataStoredInSynapse == 'no data') {
					SetAzureSynapseNoData(true)
				} else {
					let azureSynaps = summaryApiRes?.data?.dataStoredInSynapse?.[0]?.['VALUE'] ?? 0
					SetAzureSynapse(formatByByte(conversionUnit, azureSynaps));
					SetAzureSynapseRaw(azureSynaps);
				}
				if (summaryApiRes?.data?.dataStoredInCosmos == 'no data') {
					SetAzureCosmosNoData(true)
				} else {
					let azureCosmos = summaryApiRes?.data?.dataStoredInCosmos?.[0]?.['VALUE'] ?? 0;
					SetAzureCosmos(formatByByte(conversionUnit, azureCosmos));
					SetAzureCosmosRaw(azureCosmos);
				}
			})
			.catch((error: any) => {
				console.error(error);
			})
			.finally(() => {
				setIsLoading(false);
			})
	}

	useEffect(() => {
		if (hasDrillDown) {
			const selectedSector = localStorage.getItem('selectedSector');
			if (selectedSector) {
				const selectedSec = JSON.parse(selectedSector).length ? JSON.parse(selectedSector) : '';
				setCheckedList(selectedSec);
				setCurrSectorFilter(selectedSec);
			}
		} else {
			localStorage.removeItem('selectedSector');
		}

		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;
		if (userSector === 'all') fetchSectorOptionsData();
		const activeId = document.getElementById('root');
		if (window.location.pathname === '/dataestate/storagesummary') {
			if (activeId) {
				document.head.classList.add('theme-bg-blue');
				document.body.classList.add('theme-bg-blue');
				document.body.classList.add('custom-class');
				activeId.classList.add('jobs-list-table');
				activeId.classList.remove('jobs-list');
				activeId.classList.remove('root');
				document.body.classList.add('jobs-exe-datas');
				document.body.classList.remove('jobs-run-table');
				document.body.classList.add('jobs-list-datas');
				document.body.classList.add('datefilter-align-sector');
				document.body.classList.add('sector-label');
				document.body.classList.add('byte');
			}
		} else {
			if (activeId) {
				document.body.classList.remove('jobs-list-datas');
				activeId.classList.add('root');
				document.body.classList.add('dashboard-panel-dataestate');
				document.body.classList.add('datefilter-align-sector');
			}
		}
		getStorageSummaryDetails(sectorName, filterMonth, '');
	}, []);

	async function programListingFunc(pageNumber: any, size: any, sortingInfo: any, dimension: any) {
		console.log(dimension, 'data');
		let month = customMonth ? customMonth : filterMonth;
		const res = await fetchDEStorageTable('storage', dimension.current, sectorName, month);
		if (res.success) {
			setTableData(res.data.summary);
			setPaginationData(res.data.page);
			setPage(pageNumber);
			setPageSize(size);
			setSortingInfo(sortingInfo);
			setTimeout(() => {
				if (tableRef.current) {
					tableRef.current.scrollIntoView({ behavior: 'smooth' });
				}
			}, 1000);
		}
		console.log(defaultColumnNames, 'default final');
	}
	interface Teradata {
		dataBaseName: string;
		usedSpaceInGB: string;
		maxSpaceInGB: string;
		percentageUsed: string;
		remainingSpaceInGB: string;
	}
	interface ADLS {
		azureSubscription: string;
		resourceGroup: string;
		storageAccountName: string;
		fileName: string;
		usedCapacityInGB: string;
	}
	interface SQL {
		azureSubscription: string;
		resourceGroup: string;
		sqlDatabase: string;
		usedSpaceInGB: string;
		dataSpaceAllocatedInGB: string;
		dataSpaceAllocatedButUnused: string;
		dataMaxSize: string;
	}

	interface Row { }
	function getColumns(): Array<Column<Row>> {
		if (typeName === 'Data Stored in Teradata') {
			return [
				{
					key: 'dataBaseName',
					name: 'Database name',
					minWidth: 180
				},
				{
					key: 'usedSpaceInGB',
					name: 'Used space in GB',
					minWidth: 170
				},
				{
					key: 'maxSpaceInGB',
					name: 'Max space in GB',
					minWidth: 170
				},
				{
					key: 'percentageUsed',
					name: 'Percentage used',
					minWidth: 170
				},
				{
					key: 'remainingSpaceInGB',
					name: 'Remaining space in GB',
					minWidth: 170
				}
			];
		} else if (typeName === 'Data Stored in ADLS  & Blob') {
			return [
				{
					key: 'azureSubscription',
					name: 'Azure subscription',
					minWidth: 180
				},
				{
					key: 'resourceGroup',
					name: 'Resource group',
					minWidth: 170
				},
				{
					key: 'storageAccountName',
					name: 'Storage account name',
					minWidth: 170
				},
				{
					key: 'fileName',
					name: 'File name',
					minWidth: 170
				},
				{
					key: 'usedCapacityInGB',
					name: 'Used Capacity in GB',
					minWidth: 170
				}
			];
		} else if (typeName === 'Data Stored in Azure SQL') {
			return [
				{
					key: 'azureSubscription',
					name: 'Azure subscription',
					minWidth: 180
				},
				{
					key: 'resourceGroup',
					name: 'Resource group',
					minWidth: 170
				},
				{
					key: 'sqlDatabase',
					name: 'SQL database',
					minWidth: 170
				},
				{
					key: 'usedSpaceInGB',
					name: 'Used space in GB',
					minWidth: 170
				},
				{
					key: 'dataSpaceAllocatedInGB',
					name: 'Data space allocated in GB',
					minWidth: 170
				},
				{
					key: 'dataSpaceAllocatedButUnused',
					name: 'Data space allocated but unused',
					minWidth: 170
				},
				{
					key: 'dataMaxSize',
					name: 'Data max size',
					minWidth: 170
				}
			];
		} else {
			return [];
		}
	}
	const TeradataColumns = [
		'Database name',
		'Used space in GB',
		'Max space in GB',
		'Percentage used',
		'Remaining space in GB'
	];
	const ADLSColumns = [
		'Azure subscription',
		'Resource group',
		'Storage account name',
		'File name',
		'Used Capacity in GB'
	];
	const SQLColumns = [
		'Azure subscription',
		'Resource group',
		'SQL database',
		'Used space in GB',
		'Data space allocated in GB',
		'Data space allocated but unused',
		'Data max size'
	];
	const [defaultColumnNames, setDynamicValue] = useState(['']);
	const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
	const [paginationData, setPaginationData] = useState({ totalElements: 0, totalPages: 0 });
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);
	const [isTableVisible, setIsTableVisible] = useState(false);
	const tableRef = useRef<HTMLDivElement>(null);
	const [tableDataList, setTableData] = useState<Row[]>([]);
	const [tableHeading, setTableHeading] = useState('');
	const [typeName, setTypeName] = useState('');
	const dimension = useRef('');
	const [customMonth] = useState('');
	async function sectorListingFunc(pageNumber: any, size: any, sortingInfo: any) {
		const res = await getSectorSql(pageNumber.toString(), size.toString(), sortingInfo);
		if (res.success) {
			setPaginationData(res.data.page);
			setPage(pageNumber);
			setPageSize(size);
			setSortingInfo(sortingInfo);
			setTableData(res.data.sectorName);
		}
	}
	const handleSorting = (sortingInfo: any) => {
		sectorListingFunc(page, pageSize, sortingInfo);
	};
	const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
		sectorListingFunc(value, pageSize, sortingInfo);
	};
	const handlepageSizeChange = (event: any) => {
		sectorListingFunc(page, event.target.value, sortingInfo);
	};
	const handleClick = (typeName: any) => {
		setDynamicValue(['']);
		setTableData([]);
		setIsTableVisible(true);
		if (typeName === 'Data Stored in Teradata') {
			console.log('default before', defaultColumnNames);
			setDynamicValue(TeradataColumns);
			setTableHeading('Data Stored in Teradata');
			type Row = keyof Teradata;
			setTypeName('Data Stored in Teradata');
			dimension.current = 'teradata';
			console.log('default', defaultColumnNames);
		}
		if (typeName === 'Data Stored in ADLS  & Blob') {
			console.log('default before', defaultColumnNames);
			setDynamicValue(ADLSColumns);
			setTableHeading('Data Stored in ADLS  & Blob');
			type Row = keyof ADLS;
			setTypeName('Data Stored in ADLS  & Blob');
			dimension.current = 'storage';
			console.log('default', defaultColumnNames);
		}
		if (typeName === 'Data Stored in Azure SQL') {
			console.log('default before', defaultColumnNames);
			setDynamicValue(SQLColumns);
			setTableHeading('Data Stored in Azure SQL');
			type Row = keyof SQL;
			setTypeName('Data Stored in Azure SQL');
			dimension.current = 'azure_sql';
			console.log('default', defaultColumnNames);
		}
		programListingFunc(page, pageSize, sortingInfo, dimension);
	};

	const handleByteChange = (value: string) => {
		selectedByte.current = value;
		SetTeradataSize(formatByByte(value, TeradataSizeRaw.toString()));
		SetAdlsSize(formatByByte(value, AdlsSizeRaw.toString()));//
		SetAzureSqlSize(formatByByte(value, AzureSqlSizeRaw.toString()));
		SetAzureSynapse(formatByByte(value, AzureSynapseRaw.toString()));
		SetAzureCosmos(formatByByte(value, AzureCosmosRaw.toString()));
		teradataTrend(teradataRes);
		azureTrend(azureRes);
	};

	const handleSectorChange = (value: string) => {
		setLoading(true);
		setSectorName(value);
		sectorTagUpdatefun(value);
	};

	const sectorTagUpdatefun = (sector: string) => {
		if (sector != 'all') {
			if (sector == 'Blank')
				sector = '';

			const isInAzure = allSectorOptionsList?.azure.some(item => item.sector === sector);
			const filteredData = {
				azure: isInAzure || false
			};
			setSectorTagList(filteredData);
			if (filteredData.azure) getStorageSummaryDetails(filteredData.azure ? sector : 'all', filterMonth, 'sector');
		} else {
			const filteredData = {
				azure: true
			};
			setSectorTagList(filteredData);
			getStorageSummaryDetails(sector, filterMonth, 'sector');
		}
	}

	const azureSectorLabel = sectorTagList?.azure ? (sectorName === 'all' ? '' : sectorName) : '';

	const adlsNumber = sectorTagList?.azure
		? AdlsSizeNoData
			? ''
			: formatNumber(AdlsSize)
		: formatNumber(formatByByte(conversionUnit, allSectorStorageData.dataStoredInADLS?.[0]?.['VALUE']));

	const azureSqlNumber = sectorTagList?.azure
		? AzureSqlSizeNoData
			? ''
			: formatNumber(AzureSqlSize)
		: formatNumber(formatByByte(conversionUnit, allSectorStorageData.dataStoredInSQL?.[0]?.['VALUE']));

	const synapseNumber = sectorTagList?.azure
		? AzureSynapseNoData
			? ''
			: formatNumber(AzureSynapse)
		: formatNumber(formatByByte(conversionUnit, allSectorStorageData.dataStoredInSynapse?.[0]?.['VALUE']));

	const cosmosNumber = sectorTagList?.azure
		? AzureCosmosNoData
			? ''
			: formatNumber(AzureCosmos)
		: formatNumber(formatByByte(conversionUnit, allSectorStorageData.dataStoredInCosmos?.[0]?.['VALUE']));

	useEffect(() => {
		setRightContextContent(
			<Box display="flex" alignItems="center" gap={2}>
				{!!teradataStorageLastSyncDate && (
					<Stack direction="row" alignItems="center" color={`${colors.DropdownV2?.dropdownIconDefault} !important`} gap={0.5}>
						<RefreshIcon />
						<Typography variant="bodyText" sx={{ fontWeight: 400 }} component="span">
							Last Sync: {teradataStorageLastSyncDate}
						</Typography>
					</Stack>
				)}
				<ConversionUnitDropdown
					handleChange={handleByteChange}
					prefixLabel="Data in "
					dropdownIcon={KeyboardArrowDownIcon}
					selectedTextColor={colors.DropdownV2?.dropdownIconDefault}
					textColor={colors.DropdownV2?.menuItemText}
					iconColor={colors.DropdownV2?.dropdownIconDefault}
					bgColor={colors.DropdownV2?.menuItemBackground}
					borderColor="transparent"
					hoverBgColor={colors.DropdownV2?.menuItemHover}
					hoverTextColor={colors.DropdownV2?.menuItemHoverText}
					selectedBgColor={colors.DropdownV2?.menuItemSelectedBg}
					boxProps={{
						sx: {
							backgroundColor: 'transparent !important',
							minWidth: '105px',
							'& .MuiOutlinedInput-root': {
								backgroundColor: 'transparent !important'
							},
							'& .MuiSelect-select': {
								fontFamily: 'Montserrat',
								fontSize: '14px',
								fontWeight: 400,
								padding: '0 26px 0 0 !important',
								minHeight: '28px !important',
								display: 'flex',
								alignItems: 'center'
							},
							'& .MuiOutlinedInput-notchedOutline': {
								border: 'none !important'
							},
							'& .MuiSelect-icon': {
								color: `${colors.DropdownV2?.dropdownIconDefault} !important`,
								right: 0
							}
						}
					}}
				/>

				<SingleSelectFilter
					sectorName={sectorName}
					setSectorName={setSectorName}
					sectorOptionsList={sectorOptionsList}
					handleChange={handleSectorChange}
				/>
			</Box>,
		);

		return () => {
			setRightContextContent(null);
		};
	}, [sectorName, sectorOptionsList, conversionUnit, setRightContextContent]);

	return (
		<PageWrapper>
			<Grid container spacing={2} p={{ md: 2 }} mt={1}>
				<Grid item container xs={12}>
					<WidgetCardContainer bgColor={theme.palette?.kpiTile?.background?.hover} title='Data Stored in'>
						<Grid container spacing={1}>
							<Grid item xs={12} md={6} id="teradata">
								<NumberWidget
									title={<HighlightedText text="Teradata" />}
									tooltipLabel=""
									number={formatNumber(TeradataSize)}
									units={conversionUnit}
									isLoading={TeradataSize === '-'}
									handleEvent={isEnvTypePROD ? undefined : () => handleClick('Data Stored in Teradata')}
									bgColor={theme.palette?.widget?.background?.card}
									color={theme.palette?.widget?.text?.main}
									valueFontWeight={300}
									sameDecimalSize={true}
									sectorChipBgColor={theme.palette?.filterDropdown?.chipBackground}
									sectorChipColor={theme.palette?.filterDropdown?.chipText}
								/>
							</Grid>
							<Grid item xs={12} md={6} id="adls-blob">
								<NumberWidget
									title={<HighlightedText text="ADLS & Blob" />}
									tooltipLabel=""
									// number={AdlsSizeNoData == true ? '': formatNumber(AdlsSize)}
									number={adlsNumber}
									units={conversionUnit}
									isLoading={AdlsSizeNoData ? false : AdlsSize === '-'}
									handleEvent={isEnvTypePROD ? undefined : () => handleClick('Data Stored in ADLS  & Blob')}
									sectorLabel={azureSectorLabel}
									bgColor={theme.palette?.widget?.background?.card}
									color={theme.palette?.widget?.text?.main}
									valueFontWeight={300}
									sameDecimalSize={true}
									sectorChipBgColor={theme.palette?.filterDropdown?.chipBackground}
									sectorChipColor={theme.palette?.filterDropdown?.chipText}
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={4} id="azuresql">
								<NumberWidget
									title={<HighlightedText text="Azure SQL" />}
									tooltipLabel=""
									number={azureSqlNumber}
									units={conversionUnit}
									isLoading={AzureSqlSizeNoData ? false : AzureSqlSize === '-'}
									handleEvent={isEnvTypePROD ? undefined : () => handleClick('Data Stored in Azure SQL')}
									sectorLabel={azureSectorLabel}
									bgColor={theme.palette?.widget?.background?.card}
									color={theme.palette?.widget?.text?.main}
									valueFontWeight={300}
									sameDecimalSize={true}
									sectorChipBgColor={theme.palette?.filterDropdown?.chipBackground}
									sectorChipColor={theme.palette?.filterDropdown?.chipText}
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={4} id="synapse">
								<NumberWidget
									title={<HighlightedText text="Synapse" />}
									tooltipLabel=""
									number={synapseNumber}
									units={conversionUnit}
									isLoading={AzureSynapseNoData ? false : AzureSynapse === '-'}
									sectorLabel={azureSectorLabel}
									bgColor={theme.palette?.widget?.background?.card}
									color={theme.palette?.widget?.text?.main}
									valueFontWeight={300}
									sameDecimalSize={true}
									sectorChipBgColor={theme.palette?.filterDropdown?.chipBackground}
									sectorChipColor={theme.palette?.filterDropdown?.chipText}
								/>
							</Grid>
							<Grid item xs={12} lg={4} id="cosmos">
								<NumberWidget
									title={<HighlightedText text="Cosmos" />}
									tooltipLabel=""
									// number={AzureCosmosNoData == true ? '' : formatNumber(AzureCosmos)}
									number={cosmosNumber}
									units={conversionUnit}
									isLoading={AzureCosmosNoData ? false : AzureCosmos === '-'}
									sectorLabel={azureSectorLabel}
									bgColor={theme.palette?.widget?.background?.card}
									color={theme.palette?.widget?.text?.main}
									valueFontWeight={300}
									sameDecimalSize={true}
									sectorChipBgColor={theme.palette?.filterDropdown?.chipBackground}
									sectorChipColor={theme.palette?.filterDropdown?.chipText}
								/>
							</Grid>
						</Grid>
					</WidgetCardContainer>
				</Grid>
				<Grid item container xs={12}>
					<WidgetCardContainer bgColor={theme.palette?.kpiTile?.background?.hover} title='Data Trend'>
						<Grid container spacing={1}>
							<Grid item xs={12} md={6} id="teradata-trend">
								<ChartWidget
									title={<HighlightedText text="Teradata Trend" />}
									data={grafanaTeradataOptions}
									isLoading={grafanaTeradataOptions == null}
									conversionUnitProp='byte'
									lastUpdatedDate={lastUpdatedDateTeradata}
									isDataEstateTrend
									themeMode='lightTrend'
								/>
							</Grid>
							<Grid item xs={12} md={6} id="azure-trend">
								<ChartWidget
									title={<HighlightedText text="Azure Trend" />}
									data={grafanaAzureOptions}
									isLoading={isLoading}
									conversionUnitProp='byte'
									lastUpdatedDate={lastUpdatedDateAzure}
									sectorLabel={sectorTagList?.azure ? sectorName == 'all' ? '' : sectorName : ''}
									isDataEstateTrend
									themeMode='lightTrend'
								/>
							</Grid>
						</Grid>
					</WidgetCardContainer>
				</Grid>
			</Grid>
			{isTableVisible && (
				<>
					<h2 className="panel-legend--title mt-35 ">{tableHeading}</h2>
					<div className=" finop_tabledata detail_sum_tbl" ref={tableRef}>
						<Grid>
							{tableDataList && tableDataList.length > 0 ? (
								<CustomizedDataGrid
									tableColumns={getColumns()}
									tableData={tableDataList}
									tableType="sector"
									defaultColumnNames={defaultColumnNames}
									onSorting={handleSorting}
									currSorting={sortingInfo}
									page={page}
									pageSize={pageSize}
									paginationData={paginationData}
									listLength={tableDataList.length}
									handlepageSizeChange={handlepageSizeChange}
									handlePageChange={handlePageChange}
									isDateRangeFilter={false}
									isDisabled={false}
									isFetching={true}
								/>
							) : tableDataList ? (
								<LoaderComponent />
							) : (
								<span style={{ display: 'flex', justifyContent: 'center' }}>No Records Found</span>
							)}
						</Grid>
					</div>
				</>
			)}
		</PageWrapper>
	);
};

export default StorageSummary;
